export default __webpack_public_path__ + "static/media/hvj.4e347a58.jpg";